import { jsx as _jsx } from "react/jsx-runtime";
import ClearIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/Clear.js";
import { applyTokens } from "../../../utilities/applyTokens.js";
const createStates = (tokens, state) => {
    const { default: defaultState, hover, focus, disabled, error } = state;
    const { chip } = tokens.component;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { "&:not(.Mui-disabled)": {
            "&:hover": Object.assign(Object.assign({}, applyTokens(hover)), { ".MuiChip-deleteIcon": {
                    color: chip.hover.color.value,
                } }),
            "&:focus": Object.assign({}, applyTokens(focus)),
            "&:active": {
                boxShadow: "none",
            },
        }, "&.Mui-disabled": Object.assign({}, applyTokens(disabled)), "&.MuiChip-colorError": Object.assign(Object.assign({}, applyTokens(error)), { "& svg": {
                color: chip.error.icon.color.value,
            } }) });
};
const chipTheme = (tokens) => {
    const { chip } = tokens.component;
    return {
        MuiChip: {
            defaultProps: {
                deleteIcon: _jsx(ClearIcon, {}),
            },
            styleOverrides: {
                outlined: Object.assign({}, createStates(tokens, {
                    default: chip.default,
                    hover: chip.hover,
                    focus: chip.focus,
                    disabled: chip.disabled,
                    error: chip.error,
                })),
                label: {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
                labelSmall: Object.assign({}, applyTokens(chip.small.label)),
                labelLarge: Object.assign({}, applyTokens(chip.large.label)),
                sizeSmall: Object.assign(Object.assign({}, applyTokens(chip.small)), { "&:has(svg)": Object.assign({}, applyTokens(chip.small.withIcon)) }),
                sizeLarge: Object.assign(Object.assign({}, applyTokens(chip.large)), { "&:has(svg)": Object.assign({}, applyTokens(chip.large.withIcon)) }),
                deleteIcon: {
                    margin: 0,
                    color: "inherit",
                },
                deleteIconSmall: Object.assign({}, applyTokens(chip.small.icon)),
                deleteIconLarge: Object.assign({}, applyTokens(chip.large.icon)),
            },
        },
    };
};
export default chipTheme;
//# sourceMappingURL=chip.js.map